(() => {
  const notice = document.getElementById('kz-demo-notice');
  if (!notice || typeof notice.showModal !== 'function') return;
  const key = 'gerhau-kz-demo-dismissed-v1';
  let dismissed = false;
  try {
    dismissed = localStorage.getItem(key) === 'yes';
    if (!dismissed && sessionStorage.getItem(key) === 'yes') {
      localStorage.setItem(key, 'yes');
      dismissed = true;
    }
  } catch (_) {
    try { dismissed = sessionStorage.getItem(key) === 'yes'; } catch (_) {}
  }
  if (dismissed) return;
  const remember = () => {
    try { localStorage.setItem(key, 'yes'); }
    catch (_) { try { sessionStorage.setItem(key, 'yes'); } catch (_) {} }
  };
  notice.addEventListener('close', remember);
  notice.querySelector('[data-demo-close]').addEventListener('click', () => notice.close());
  notice.showModal();
})();
